module.exports = __webpack_public_path__ + "static/media/german_heavy_artiilery.41a57330.png";